import { createClient } from '@supabase/supabase-js';

// Replace these with your actual Supabase project credentials
// You can find these in your Supabase project settings
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://pczgetywnpfbgecnvaza.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBjemdldHl3bnBmYmdlY252YXphIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYyMjM4MzUsImV4cCI6MjA4MTc5OTgzNX0.zpAqEUyFO-mkg7qEjZTTDLb1dBTO0kIilh3B5pSGml8';

// Debug: Log which Supabase URL is being used
console.log('🔗 Supabase Configuration:', {
  url: supabaseUrl,
  fromEnv: !!process.env.REACT_APP_SUPABASE_URL,
  isNewProject: supabaseUrl.includes('pczgetywnpfbgecnvaza')
});

// Check if Supabase is properly configured
export const isSupabaseConfigured = () => {
  return supabaseUrl && 
         supabaseAnonKey && 
         supabaseUrl !== 'YOUR_SUPABASE_URL' && 
         supabaseAnonKey !== 'YOUR_SUPABASE_ANON_KEY' &&
         supabaseUrl.startsWith('http');
};

// Create Supabase client only if configured, otherwise return null
let supabase = null;

if (isSupabaseConfigured()) {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey);
  } catch (error) {
    console.warn('Failed to initialize Supabase client:', error);
    supabase = null;
  }
}

export { supabase };

